import { gql } from '../../../../../hooks'

export const LIST_SHIFT_CHANGES = gql`
  query ListShiftChanges {
    t7ShiftChangeList {
      data
    }
  }
`
